import { render, staticRenderFns } from "./blood_related.vue?vue&type=template&id=77d7804d&scoped=true&"
import script from "./blood_related.vue?vue&type=script&lang=js&"
export * from "./blood_related.vue?vue&type=script&lang=js&"
import style0 from "./blood_related.vue?vue&type=style&index=0&id=77d7804d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d7804d",
  null
  
)

export default component.exports